package features.auth.handlers

import features.auth.domain.User
import AppState
import Router
import core.firebase.FirebaseService

// Auth Event Handlers
fun handleLogin() {
    console.log("Login clicked")
    AppState.isLoading = true
    Router.render()
    
    FirebaseService.signInWithGoogle()
        .then { credential ->
            try {
                console.log("🎯 Got credential, extracting user...")
                val user = credential.user
                console.log("✅ User extracted:", user)
                
                console.log("📧 Accessing user properties...")
                val displayName = user.displayName
                val email = user.email  
                val uid = user.uid
                val photoURL = user.photoURL
                
                console.log("Login successful: $displayName")
                console.log("User email: $email")
                console.log("User UID: $uid")
                console.log("User photo: $photoURL")
                
                // Create User object
                console.log("🏗️ Creating User object...")
                val appUser = User(
                    id = uid,
                    name = displayName ?: "Unknown",
                    email = email ?: "",
                    avatar = photoURL ?: "https://ui-avatars.com/api/?name=$displayName&background=06b6d4&color=fff"
                )
                
                console.log("AppUser created:", appUser)
                AppState.currentUser = appUser
                console.log("AppState.currentUser set")
                
                // Save user to Firestore
                console.log("Calling createOrUpdateUser...")
                features.auth.data.UserRepository.createOrUpdateUser(appUser)
                    .then {
                        console.log("User saved successfully!")
                        AppState.isLoading = false
                        console.log("Navigating to dashboard...")
                        Router.navigateTo("dashboard")
                        console.log("Navigation called")
                    }
                    .catch { error ->
                        console.error("Error saving user:", error)
                        AppState.isLoading = false
                        kotlinx.browser.window.alert("Error saving user data")
                    }
            } catch (e: dynamic) {
                console.error("❌ Error in login handler:", e)
                console.error("Error message:", e.message)
                console.error("Error stack:", e.stack)
                AppState.isLoading = false
                kotlinx.browser.window.alert("Error processing login: ${e.message}")
            }
        }
        .catch { error ->
            console.error("Login error:", error)
            AppState.isLoading = false
            Router.render()
            kotlinx.browser.window.alert("Login failed. Please try again.")
        }
}

fun handleLogout() {
    FirebaseService.signOut()
        .then {
            AppState.currentUser = null
            AppState.teams.clear()
            AppState.currentTeam = null
            Router.navigateTo("login")
        }
        .catch { error ->
            console.error("Logout error:", error)
            kotlinx.browser.window.alert("Logout failed")
        }
}

fun handleDevLogin() {
    console.log("🔓 Dev Login initiated")
    val devUser = User(
        id = "dev_user_123",
        name = "Dev Tester",
        email = "dev@example.com",
        avatar = "https://ui-avatars.com/api/?name=Dev+Tester&background=random"
    )
    
    // Set global state
    AppState.currentUser = devUser
    
    // Optimistically save to store (fire and forget)
    features.auth.data.UserRepository.createOrUpdateUser(devUser)
        .catch { console.warn("Dev user sync failed (expected if offline/no-auth)") }
    
    // Load teams before navigating
    features.teams.data.TeamRepository.loadUserTeams(devUser.id)
        .then { teams ->
            console.log("✅ Teams loaded:", teams.size)
            AppState.teams.clear()
            AppState.teams.addAll(teams)
            AppState.teamsLoaded = true
            Router.navigateTo("dashboard")
        }
        .catch { error ->
            console.warn("Dev user has no teams (expected):", error)
            AppState.teamsLoaded = true // Mark as loaded even if empty
            Router.navigateTo("dashboard")
        }
}
